module.exports = __webpack_public_path__ + "static/media/about_top_min.f08e201c.jpg";